import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Emidetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.EMIURL_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.EMIURL_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.EMIURL_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}